import { render, staticRenderFns } from "./StoreHomepage.vue?vue&type=template&id=0424e6d9&scoped=true&"
import script from "./StoreHomepage.vue?vue&type=script&lang=js&"
export * from "./StoreHomepage.vue?vue&type=script&lang=js&"
import style0 from "./StoreHomepage.vue?vue&type=style&index=0&id=0424e6d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424e6d9",
  null
  
)

export default component.exports